import {Controller} from "stimulus";
import Cookies from "js-cookie";

export default class DismissablePanelController extends Controller<HTMLElement> {
  static targets = ["body", "control"];
  static values = {
    dismissed: {type: Boolean, default: false},
    dismissedStateCookieName: String,
  };

  declare readonly bodyTarget: HTMLElement;
  declare readonly controlTarget: HTMLElement;

  declare dismissedValue: boolean;
  declare hasDismissedStateCookieNameValue: boolean;
  declare dismissedStateCookieNameValue: string;

  toggle() {
    this.dismissedValue = !this.dismissedValue;
    if (this.dismissedValue) {
      this.bodyTarget.classList.add("hidden");
      this.controlTarget.classList.remove("hidden");
    } else {
      this.bodyTarget.classList.remove("hidden");
      this.controlTarget.classList.add("hidden");
    }
    this.updateState();
  }

  updateState(): void {
    if (!this.hasDismissedStateCookieNameValue) return;
    Cookies.set(this.dismissedStateCookieNameValue, this.dismissedValue.toString(), {sameSite: "strict"});
  }
}
